export scroll_to_element = (selector) ->
  el = document.querySelector(selector)
  box = el.getBoundingClientRect()

  scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  clientTop = document.documentElement.clientTop || document.body.clientTop || 0
  header = document.querySelector('#app-bar')
  top = box.top +  scrollTop - clientTop - header.clientHeight - 64

  window.scroll left: 0, top: top, behavior: 'smooth'